import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AsIconComponent } from '@modules/editor/shared/as-components/icon/icon.component';

export enum ButtonVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  DarkStyle = 'darkstyle',

  Ghost = 'ghost',
  Outline = 'outline',
}

export enum ButtonType {
  Icon = 'icon',
  Button = 'button',
  All = 'all',
}

export enum ButtonSize {
  Special = 'special',
  Large = 'large',
  Small = 'small',
}

export enum ButtonIconPosition {
  Left = 'left',
  Right = 'right',
}

@Component({
  selector: 'as-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: true,
  imports: [
    AsIconComponent,
    NgIf,
  ],
})
export class AsButtonComponent {
  @Input() label = 'Click me';
  @Input() variant: ButtonVariant = ButtonVariant.Primary;
  @Input() type: ButtonType = ButtonType.Button;
  @Input() size: ButtonSize = ButtonSize.Large;
  @Input() disabled = false;
  @Input() iconPosition: ButtonIconPosition = ButtonIconPosition.Left;
  @Input() customClass = '';
  @Input() iconName = 'error'; // Nazwa ikony
  @Input() iconSize = 24; // Rozmiar ikony
  @Input() iconColorClass = ''; // Klasa koloru ikony
  @Input() useSubmitBehavior = false;
  @Output() onClick: EventEmitter<Event> = new EventEmitter<Event>();

  buttonType = ButtonType;
  buttonIconPosition = ButtonIconPosition;

  get classes(): string[] {
    const classes: string[] = [this.variant, this.size];

    if (this.type === ButtonType.Icon) {
      classes.push('icon-only');
    }

    if (this.iconPosition === ButtonIconPosition.Left) {
      classes.push('icon-left');
    } else if (this.iconPosition === ButtonIconPosition.Right) {
      classes.push('icon-right');
    }

    if (this.disabled) {
      classes.push('disabled');
    }

    if (this.customClass) {
      classes.push(this.customClass);
    }

    return classes;
  }

  get showIcon(): boolean {
    return this.type === ButtonType.Icon || this.type === ButtonType.All;
  }

  get showLabel(): boolean {
    return this.type === ButtonType.Button || this.type === ButtonType.All;
  }

  handleClick(event: Event): void {
    if (!this.disabled) {
      this.onClick.emit(event);
    }
  }
}
